import { gql } from "@apollo/client";

// ==================== ROOM QUERIES (PUBLIC) ====================

export const CHAT_ROOM_BY_SLUG = gql`
  query ChatRoomBySlug($slug: String!) {
    chatRoomBySlug(slug: $slug) {
      id
      slug
      title
      description
      type
      status
      participantCount
      messageCount
      lastMessageAt
      createdAt
    }
  }
`;

// ==================== ROOM AUTO-CREATE (PUBLIC) ====================

export const ENSURE_CHAT_ROOM = gql`
  mutation EnsureChatRoom($slug: String!, $title: String!, $description: String) {
    ensureChatRoom(slug: $slug, title: $title, description: $description) {
      id
      slug
      title
      description
      type
      status
      participantCount
      messageCount
      createdAt
    }
  }
`;

// ==================== ROOM MUTATIONS (PUBLIC) ====================

export const JOIN_CHAT_ROOM = gql`
  mutation JoinChatRoom($roomId: ID!, $displayName: String, $anonToken: String) {
    joinChatRoom(roomId: $roomId, displayName: $displayName, anonToken: $anonToken) {
      participantId
      anonToken
      displayName
      roomId
      participantType
    }
  }
`;

// ==================== MESSAGE QUERIES (PUBLIC) ====================

export const CHAT_MESSAGES = gql`
  query ChatMessages($roomId: ID!, $limit: Int, $before: ID) {
    chatMessages(roomId: $roomId, limit: $limit, before: $before) {
      id
      roomId
      senderId
      senderName
      senderType
      content
      contentType
      replyToId
      editedAt
      isDeleted
      createdAt
    }
  }
`;

// ==================== MESSAGE MUTATIONS (PUBLIC) ====================

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage($input: SendMessageInput!, $anonToken: String) {
    sendChatMessage(input: $input, anonToken: $anonToken) {
      id
      roomId
      senderId
      senderName
      senderType
      content
      contentType
      replyToId
      createdAt
    }
  }
`;

// ==================== PARTICIPANT QUERIES (PUBLIC) ====================

export const CHAT_PARTICIPANTS = gql`
  query ChatParticipants($roomId: ID!) {
    chatParticipants(roomId: $roomId) {
      id
      roomId
      participantId
      participantType
      displayName
      role
      joinedAt
      lastSeenAt
      isTyping
    }
  }
`;

// ==================== TYPING / PRESENCE (PUBLIC) ====================

export const UPDATE_TYPING_STATUS = gql`
  mutation UpdateTypingStatus($roomId: ID!, $isTyping: Boolean!, $anonToken: String) {
    updateTypingStatus(roomId: $roomId, isTyping: $isTyping, anonToken: $anonToken)
  }
`;

export const UPDATE_LAST_SEEN = gql`
  mutation UpdateLastSeen($roomId: ID!, $anonToken: String) {
    updateLastSeen(roomId: $roomId, anonToken: $anonToken)
  }
`;

// ==================== IDENTITY LINKING ====================

export const LINK_ANONYMOUS_CHAT_IDENTITY = gql`
  mutation LinkAnonymousChatIdentity($anonToken: String!) {
    linkAnonymousChatIdentity(anonToken: $anonToken)
  }
`;

// ==================== SUBSCRIPTIONS ====================

export const CHAT_MESSAGE_ADDED_SUBSCRIPTION = gql`
  subscription ChatMessageAdded($roomId: ID!) {
    chatMessageAdded(roomId: $roomId) {
      id
      roomId
      senderId
      senderName
      senderType
      content
      contentType
      replyToId
      createdAt
    }
  }
`;

export const CHAT_TYPING_SUBSCRIPTION = gql`
  subscription ChatTypingUpdate($roomId: ID!) {
    chatTypingUpdate(roomId: $roomId) {
      participantId
      displayName
      isTyping
    }
  }
`;

// ==================== ADMIN QUERIES ====================

export const GET_CHAT_ROOMS = gql`
  query GetChatRooms($status: ChatRoomStatus) {
    chatRooms(status: $status) {
      id
      slug
      title
      description
      type
      status
      participantCount
      messageCount
      lastMessageAt
      lastMessagePreview
      isPublic
      createdAt
    }
  }
`;

export const GET_CHAT_ROOM = gql`
  query GetChatRoom($id: ID!) {
    chatRoom(id: $id) {
      id
      slug
      title
      description
      type
      status
      participantCount
      messageCount
      lastMessageAt
      lastMessagePreview
      isPublic
      createdBy
      createdAt
    }
  }
`;

// ==================== ADMIN MUTATIONS ====================

export const CREATE_CHAT_ROOM = gql`
  mutation CreateChatRoom($input: ChatRoomInput!) {
    createChatRoom(input: $input) {
      id
      slug
      title
      description
      type
      status
      isPublic
      createdAt
    }
  }
`;

export const UPDATE_CHAT_ROOM = gql`
  mutation UpdateChatRoom($id: ID!, $input: ChatRoomUpdateInput!) {
    updateChatRoom(id: $id, input: $input) {
      id
      slug
      title
      description
      type
      status
      isPublic
    }
  }
`;

export const DELETE_CHAT_ROOM = gql`
  mutation DeleteChatRoom($id: ID!) {
    deleteChatRoom(id: $id)
  }
`;

export const DELETE_CHAT_MESSAGE = gql`
  mutation DeleteChatMessage($id: ID!) {
    deleteChatMessage(id: $id)
  }
`;

export const BAN_CHAT_PARTICIPANT = gql`
  mutation BanChatParticipant($roomId: ID!, $participantId: String!) {
    banChatParticipant(roomId: $roomId, participantId: $participantId)
  }
`;
